import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';
import UrgencyBanner from '../cro/UrgencyBanner';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Shop', path: '/shop' },
    { name: 'Collections', path: '/collections' },
    { name: 'How It Works', path: '/how-it-works' },
    { name: 'Size Guide', path: '/size-guide' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 flex flex-col">
      <UrgencyBanner />
      <div className="glass border-b border-white/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">

          {/* Logo */}
          <Link to="/" className="flex items-center group">
            <img
              src="/images/logo_transparent.png"
              alt="AuraPrintiqo"
              className="h-20 md:h-24 w-auto object-contain group-hover:scale-105 transition-transform duration-300"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 ${
                  isActive(link.path)
                    ? 'bg-[hsl(350,70%,65%)]/10 text-[hsl(350,70%,55%)]'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100/50'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Link to="/contact">
              <Button className="bg-gradient-to-r from-[hsl(350,70%,65%)] to-[hsl(20,90%,70%)] hover:from-[hsl(350,70%,60%)] hover:to-[hsl(20,90%,65%)] text-white shadow-soft hover:shadow-soft-lg transition-all duration-300">
                Order Now
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-gray-100/50 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>

        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden glass border-t border-white/20 animate-fade-in-up">
          <nav className="flex flex-col py-4 px-4 gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className={`px-4 py-3 rounded-lg text-base font-medium transition-all duration-300 ${
                  isActive(link.path)
                    ? 'bg-[hsl(350,70%,65%)]/10 text-[hsl(350,70%,55%)]'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100/50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="mt-2">
              <Button className="w-full bg-gradient-to-r from-[hsl(350,70%,65%)] to-[hsl(20,90%,70%)] hover:from-[hsl(350,70%,60%)] hover:to-[hsl(20,90%,65%)] text-white">
                Order Now
              </Button>
            </Link>
          </nav>
        </div>
      )}
      </div>{/* close glass wrapper */}
    </header>
  );
};

export default Header;
